import JustValidate from 'just-validate';
export class CollegeSavings {

	constructor() {
	}
	init() {
		const calculators = document.querySelectorAll('.calculator-section.type-college_saving');
		if (!calculators) {
			return;
		}

		calculators.forEach(calculator => {
			const submitButton = calculator.querySelector('button[type=submit]');
			const form = calculator.querySelector('form');
			const validator = new JustValidate(form, {
				validateBeforeSubmitting: false,
			});
			validator.addField('#initial-deposit', [
				{
					rule: 'required',
					errorMessage: 'Please enter an amount for initial depost'
				},
				{
					rule: 'number',
					errorMessage: 'Please enter a valid number'
				},
				{
					rule: 'minNumber',
					value: 0,
					errorMessage: 'Please enter a number greater than or equal to $0'
				},
			]);
			validator.addField('#age', [
				{
					rule: 'required',
					errorMessage: 'Please enter an age'
				}
			]);
			validator.addField('#investment', [
				{
					rule: 'required',
					errorMessage: 'Please enter an monthly investment amount'
				},
				{
					rule: 'minNumber',
					value: 0,
					errorMessage: 'Please enter a number greater than or equal to $0'
				},

			]);
			validator.onSuccess((e) => {
				let principle = calculator.querySelector('input[name=initial-deposit]').value;
				const age = calculator.querySelector('select[name=age]').value;
				const money = calculator.querySelector('input[name=investment]').value;

				var r = 0.07; //yearly interest rate
				var n = 12;   //times a year this is compounded (monthly = 12)
				var t = (18 - age); //investment time

				var accountAtEnd = this.calculateNumbers(principle,money,t);
				principle = parseFloat(principle);
				var amountContributed = principle + ( money * t*n );  //the amount contributed is just monthly investment times months invested
				var interestContributed = accountAtEnd - amountContributed; //interest earned is total minus contributions

				calculator.querySelector('.value-savings').innerHTML = this.mefaCommaNum(Math.floor(accountAtEnd));
				calculator.querySelector('.value-contributions').innerHTML = this.mefaCommaNum(Math.floor(amountContributed));
				calculator.querySelector('.value-interest').innerHTML = this.mefaCommaNum(Math.floor(interestContributed));
				calculator.querySelector('.results').classList.remove('visually-hidden');

				const resultRect = calculator.querySelector('.results').getBoundingClientRect();
				if (resultRect.top < window.innerHeight && resultRect.bottom > 0) {
					return;
				}
				// window.scrollTo({
				// 	top: resultRect.top + window.pageYOffset - 100,
				// 	behavior: 'smooth'
				// });
			})
			validator.onFail((e) => {
				console.log("fail");
			});

			// let local = this;
			// calculator.querySelectorAll('input, select').forEach(function (el) {
			// 	el.addEventListener('change', function (e) {
			// 		let val = e.target.value;
			// 		if (!e.target.classList.contains('skip-validation')) {
			// 			if (val !== "") {
			// 				val = local.mefaDecStrip(val);
			// 				if (isNaN(parseFloat(val))) {
			// 					val = 0;
			// 				}
			// 				e.target.value = "$" + (parseFloat(val).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","));
			// 			} else {
			// 				e.target.value = "$0";
			// 			}
			// 		}
			// 		validator.revalidate();
			// 	});
			// });

			validator.revalidate();

		});

	}
	calculateNumbers(princ,add,years){
		princ = parseFloat(princ);
		add = parseFloat(add);
		let rate = 7 / 100; // interest rate divided to create decimal
		//let months = (10 * 12); //10 years of monthly contributions
		let months = (years * 12); //10 years of monthly contributions

		for (let i = 1; i <= months; i++) {
			princ += princ * (rate / 12);
			princ += add;
		}

		return princ;
	}
	mefaDecStrip(nStr) {
		return nStr.replace(/[^0-9\.]+/g, '')
	}

	mefaCommaNum(nStr){
		nStr += '';
		var x = nStr.split('.');
		var x1 = x[0];
		var x2 = x.length > 1 ? '.' + x[1] : '';
		var rgx = /(\d+)(\d{3})/;
		while (rgx.test(x1)) {
			x1 = x1.replace(rgx, '$1' + ',' + '$2')
		}
		return '$' + x1 + x2
	}
	addReadableComma(num) {
		var parts = num.toString().split(".");
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		return parts.join(".");
	}
}
